import { loadStripe } from '@stripe/stripe-js';
import type { Stripe as StripeJs } from '@stripe/stripe-js';
import API_BASE_URL from './config';

// TODO: Stripe hesabınızı oluşturduktan sonra bu anahtarı güncelleyin
// Dashboard > Developers > API keys bölümünden alın
// Test modu için: pk_test_... ile başlar
// Canlı modu için: pk_live_... ile başlar
const STRIPE_PUBLISHABLE_KEY = 'pk_test_51SrnaFF1mGjJtjUydQ32TY23qyu2btj2vfvf6zheFvJgI7EQRJEVFdzFoWRZ5oQkaADWN5y9Xeg6eupqqH4pG4KO00YuXn0oW1';

let stripePromise: Promise<StripeJs | null>;

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
};

// Stripe Checkout'a yönlendirme
export const redirectToCheckout = async (priceId: string) => {
  try {
    // Backend'den checkout session oluştur
    const response = await fetch(`${API_BASE_URL}/create-checkout-session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ priceId }),
    });

    const data = await response.json();

    if (data.url) {
      // Doğrudan Stripe ödeme sayfasına yönlendir
      window.location.href = data.url;
    } else {
      console.error('Stripe session URL alınamadı:', data);
      alert('Ödeme sayfası yüklenemedi. Lütfen tekrar deneyin.');
    }

  } catch (error: any) {
    console.error('Stripe Checkout hatası:', error);
    alert(`Bir hata oluştu: ${error.message || error}`);
  }
};

// Stripe Price IDs - Stripe Dashboard'dan oluşturduktan sonra buraya ekleyin
export const STRIPE_PRICES = {
  FREE: 'price_1SybpCF1mGjJtjUyNw51ou7l',
  PRO_MONTHLY: 'price_1SybrYF1mGjJtjUyDBsYBHD4', // $10/mo
  TEAM_MONTHLY: 'price_1SybsuF1mGjJtjUyGWTKKn4E', // $49/mo
};
